import type { FaireProductEntity } from "../../entity_types/product";

export const amalfi_candle: FaireProductEntity = {
  token: "amalfi-candle",
  type: "product",
  name: "Amalfi: Soy scented candle",
  brandName: "Boheme",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/df2a3127e893dbc4bd95deae69355a939068b197e376e4b3334fe357c7f88279.webp",
  priceDollars: 75,
  msrpDollars: 150,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
